import PropTypes from 'prop-types';
import React from 'react';
import C_R from '../../constants/routes';
import C_A from '../../constants/analytics';
import Style from './style.scss';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as AnalyticsAction from '../../actions/analytics';
import * as appActions from  '../../actions/app';
import { getAuth0AuthenticationFlag } from '../../actions/platformIntegration';
import { resetMixpanelUser } from '../../utils/setupMixpanel';


export class Redirect extends React.Component {

    componentWillMount() {
        this.redirectByParam();
        
    }
    
    async redirectByParam() {
        let loginUrl = '/Login.jsp';
        let redirectTo = this.props.match.params.to;
        if(redirectTo === 'login'){
            const promis = await appActions.getLoginUrl();
            loginUrl = promis.data;
        }
        
        switch (redirectTo) {
            case 'admin':
                this.props.analyticActions.reportAnalytics([C_A.REDIRECT, 'admin']);
                window.location = '/';
                break;
            case 'logout': {
                this.props.analyticActions.reportAnalytics([C_A.REDIRECT, 'logout']);
                resetMixpanelUser();
                const auth0Enabled = await getAuth0AuthenticationFlag();
                window.location = auth0Enabled
                    ? `${window.location.origin}/connect/v1/auth/logout`
                    : '/Logout.jsp';
                break;
            }
            case 'login':
                this.props.analyticActions.reportAnalytics([C_A.REDIRECT, 'login']);
                window.location = loginUrl;
                break;
            case 'sysai':
                window.location = '/sysai/ui';
                break;
            default:
                this.props.history.push(C_R.ROOT_PATH);
        }
    }
    render() {
        return (
            <div className={Style.redirectWrapper}>
                <h3 className={Style.redirectText}>Redirecting...</h3>
            </div>

        )
    }
}

Redirect.propTypes = {
    history: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    analyticActions: PropTypes.object.isRequired
};

function mapDispatchToProps(dispatch) {
    return {
        analyticActions: bindActionCreators(AnalyticsAction, dispatch)
    }
}

export default connect(null, mapDispatchToProps)(Redirect);


// WEBPACK FOOTER //
// ./components/Redirect/index.js